/**
 * Redux Store Provider
 *
 * Wraps the application with Redux Provider.
 */

import { Provider } from '@spcc/core'
import { store } from '@/store'
import type { ReactNode } from 'react'

interface StoreProviderProps {
  children: ReactNode
}

export function StoreProvider({ children }: StoreProviderProps) {
  return <Provider store={store}>{children as any}</Provider>
}
